(ns practitest.frontend.milestone.readiness-index.subs
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.milestone.readiness-index :as-alias ri]
            [practitest.frontend.milestones :as-alias milestones]
            [re-frame.core :as rf]))

(def metrics
  #:metrics
  {:ccs  "Coverage Confidence"
   :ecs  "Execution Confidence"
   :rdrs "Remaining Defects Risk"})

(def metrics->tab
  #:metrics
  {:ccs  :requirements
   :ecs  :testsets
   :rdrs :issues})

(defn- score->level [score]
  (when (some? score)
    (condp < score
      0.75 :high
      0.50 :mid
      :low)))

(def level->status
  {:high :status/ready
   :mid  :status/in-progress
   :low  :status/at-risk})

(def score->status
  (comp level->status score->level))

(defn- url-for
  [milestone & [{:keys [tab]
                 :or   {tab :general}}]]
  (router/get-href2 ::milestones/edit milestone {} {:tab tab}))

(defn- prepare-metrics [milestone]
  (for [[metric label] metrics
        
        :let [score (milestone metric)
              tab   (metrics->tab metric)]]
    {:label       label
     :url         (url-for milestone {:tab tab})
     :score       score
     :score-level (score->level score)}))

(rf/reg-sub
 ::milestone
 (fn [[_ id] _]
   (rf/subscribe [::milestones/milestone id]))
 (fn [{:keys         [milestone_start_date milestone_end_date]
       :metrics/keys [rrqi]
       :as           milestone} _]
   (let [start-date     (js/Date. milestone_start_date)
         end-date       (js/Date. milestone_end_date)
         today          (js/Date.)
         upcoming?      (< today start-date)
         not-available? (or upcoming? (nil? rrqi))
         milestone      (cond-> milestone
                          not-available?
                          (dissoc :metrics/rrqi :metrics/ccs
                                  :metrics/ecs :metrics/rdrs))]
     (merge milestone
            {:start-date         start-date
             :end-date           end-date
             ::ri/not-available? not-available?
             ::ri/status         (if not-available?
                                   :status/not-available
                                   (-> rrqi score->status))
             :url                (url-for milestone)
             :metrics            (vec (prepare-metrics milestone))}))))
